import { render, staticRenderFns } from "./chartColumnSkeleton.vue?vue&type=template&id=3ad72750&scoped=true"
import script from "./chartColumnSkeleton.vue?vue&type=script&lang=js"
export * from "./chartColumnSkeleton.vue?vue&type=script&lang=js"
import style0 from "./chartColumnSkeleton.vue?vue&type=style&index=0&id=3ad72750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad72750",
  null
  
)

export default component.exports